import { render, staticRenderFns } from "./dynamicHeader.vue?vue&type=template&id=9121279a&scoped=true"
import script from "./dynamicHeader.vue?vue&type=script&lang=js"
export * from "./dynamicHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9121279a",
  null
  
)

export default component.exports